import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Card, StatusPill } from "../components/primitives";
import { formatDateTime } from "../lib/format";

export default function ReportingFTR() {
  const [ftrs, setFtrs] = useState([]);
  useEffect(() => { api.get("/reports/ftr").then(r => setFtrs(r.data.ftrs || [])); }, []);
  return (
    <div>
      <PageHeader title="FTR — Foreign Transaction Reports" subtitle={`${ftrs.length} cross-border movements above threshold`} sections={["5.8"]} />
      <div className="p-6">
        <Card>
          <table className="dense w-full">
            <thead><tr><th>FTR ID</th><th>Customer</th><th>Counterparty</th><th>Bank</th><th>Currency</th><th className="text-right">Amount</th><th>Timestamp</th><th>Status</th></tr></thead>
            <tbody>
              {ftrs.map(f => (
                <tr key={f.id}><td className="font-medium text-[12px]">{f.id}</td><td className="text-[12px]">{f.customer_name}</td><td className="text-[12px]">{f.counterparty}</td><td className="text-[11px]">{f.counterparty_bank}</td><td className="text-[11px]">{f.currency}</td><td className="text-right tabular">{f.amount.toLocaleString()}</td><td className="text-[11px]">{formatDateTime(f.ts)}</td><td><StatusPill status={f.status} /></td></tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </div>
  );
}
